import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types.ts';

export const handleAuthUserFlowInitialData = async (
  customerId: string,
  authorizedUserId: string
): Promise<void> => {
  const setAuthOnboardingData = useBoundStore.getState().setAuthOnboardingData;
  const setOnboardingIdentifier = useBoundStore.getState().onboardingSlice.setOnboardingIdentifier;

  const { data } = await HttpService.get(
    `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}`
  );
  setAuthOnboardingData(data);
  setOnboardingIdentifier(OnboardingFlowIdentifier.AUTHORIZED_USER);
};
